import Rss from '../assets/rss.svg';

export function FeedIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Rss} alt='Feed' />;
}
